import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './Authors.css';
import { getWriters } from "../../api";
const Authors = () => {
  const [selectedLetter, setSelectedLetter] = useState('A');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const location = useLocation();
  
  const alphabet = ['A', 'B', 'C', 'Ç', 'D', 'E', 'F', 'G', 'Ğ', 'H', 'I', 'İ', 'J', 'K', 'L', 'M', 'N', 'O', 'Ö', 'P', 'R', 'S', 'Ş', 'T', 'U', 'Ü', 'V', 'Y', 'Z'];
  
  
  const letterGroups = {
    'A-E': ['A', 'B', 'C', 'Ç', 'D', 'E'],
    'F-J': ['F', 'G', 'Ğ', 'H', 'I', 'İ', 'J'],
    'K-P': ['K', 'L', 'M', 'N', 'O', 'Ö', 'P'],
    'R-Z': ['R', 'S', 'Ş', 'T', 'U', 'Ü', 'V', 'Y', 'Z'],
    
  };

  const authors = {
    'A': [
      { title: 'A. Tunalı Hilmi Bey', years: '(1871-1928)' },
      { title: 'Abdulhamit Hamdi Efendi (ÇINTAN)', years: '(1867-1928)' },
      { title: 'Abdullah Aker', years: '(1905-1977)' },
      { title: 'Abdullah Karabina', years: '(1867-1935)' },
      { title: 'Abdullah Sabri Ağaç', years: '(1870-1950)' },
      { title: 'Abdullah İsmet (Eker) Bey', years: '(1877-1962)' },
      { title: 'Abdurrahman Melek', years: '(1896-1978)' },
      { title: 'Abdurrahman Nafiz Gürman', years: '(1887-1966)' },
      { title: 'Abdülhak Adnan Adıvar', years: '(1882-1955)' },
      { title: 'Abdülhak Hamid Tarhan', years: '(1852-1937)' },
      { title: 'Abdülhalim Çelebi Efendi (Erizözü)', years: '(1874-1925)' },
      { title: 'Abdülkadir Kemali (Öğütçü) Bey', years: '(1889-1949)' },
      { title: 'Abdülkadir Noyan', years: '(1886-1977)' },
      { title: 'Abdüllâtif Naci Eldeniz', years: '(1875-1948)' },
      { title: 'Abidin Dâver', years: '(1886-1954)' },
      { title: 'Abidin Efendi (Zeynel Abidin Bayluni)', years: '(1869-1944)' },
      { title: 'Abülmipasa Köşkü' },
      { title: 'Abilov, İbrahim Muharremoglu', years: '(1882 – 1923)' },
      { title: 'Adana Görüşmesi', years: '(30-31 Ocak 1943)' },
      { title: 'Adliye Vekaleti' },
      { title: 'Adnan Cemgil', years: '(1909-2001)' },
      { title: 'Adnan Menderes', years: '(1899-1961)' },
      { title: 'Adolf Hitler', years: '(1889- 1945)' },
      { title: 'Admlar Dergisi' },
      { title: "Afetinin ve Kemal Atatürk'ün Karlsbad Hatıraları" },
      { title: 'Affife Jale', years: '(1902-1941)' },
      { title: 'Agop (Martayan) Dilaçar', years: '(1895 –1979)' },
      { title: 'Agust (Pitter von) Kral', years: '(1869 -1953)' },
      { title: 'Agâh Erozan', years: '(1910-1993)' },
      { title: 'Ahali Cumhuriyet Fırkası' },
      { title: 'Ahilya Mochus', years: '(1884-1966)' },
      { title: 'Ahmed Rıza Bey', years: '(1859-1930)' },
      { title: 'Ahmedi İhsan Tokgöz', years: '(1868 – 28 Aralık 1942)' },
      { title: 'Ahmet Adnan Saygun', years: '(1907-1991)' },
      { title: 'Ahmet Anzavur', years: '(?-1921)' },
      { title: 'Ahmet Ağaoğlu', years: '(1869-1939)' },
      { title: 'Ahmet Besim Atalay', years: '(1882–1965)' },
      { title: 'Ahmet Cevat (Lakşe)', years: '(1883-1935)' },
      { title: 'Ahmet Cevdet Oran', years: '(1862-1935)' },
      { title: 'Ahmet Derviş', years: '(1886-1932)' },
      { title: 'Ahmet Emin Yalman', years: '(1888 -1972)' },
      { title: 'Ahmet Ferit Tek', years: '(1878-1971)' },
      { title: 'Ahmet Fevzi Efendi (Erdem)', years: '(1885-1974)' },
      { title: 'Ahmet Fikri Tüzer', years: '(1878-1942)' },
      { title: 'Ahmet Fuat Bulca', years: '(1881-1962)' },
      { title: 'Ahmet Hakkı Sütekin', years: '(1867-1942)' },
      { title: 'Ahmet Hamdi Akseki', years: '(1887-1951)' },
      { title: 'Ahmet Hamdi Başar', years: '(1897-1971)' },
      { title: 'Ahmet Hilmi (Kalaç) Bey', years: '(1888-1966)' },
      { title: 'Ahmet Muhtar Fikri (Gözüm)', years: '(1876-1930)' },
      { title: 'Ahmet Muzaffer Kılıç', years: '(1897-1959)' },
      { title: 'Ahmet Mükerrem Sarol', years: '(1909-1995)' },
      { title: 'Ahmet Naci TINAZ', years: '(1882-1964)' },
      { title: 'Ahmet Naşit Mengü', years: '(1903-1964)' },
      { title: 'Ahmet Nebil Yurteri', years: '(1876-1943)' },
      { title: 'Ahmet Nureddin (Kuri) Efendi', years: '(1887- ?)' },
      { title: 'Ahmet Nuri Baydar', years: '(1866-1940)' },
      { title: 'Ahmet Rasim', years: '(1864-1932)' },
      { title: 'Ahmet Refik Altınay', years: '(1880-1937)' },
      { title: 'Ahmet Remzi Akyüzlük', years: '(1871-1938)' }
    ],
    '1': [
      { title: '19 Mayıs Stadyumu', years: '(1936)' },
      { title: '1. TBMM Binası', years: '(1920-1924)' },
      { title: '1. Türk Tarih Kongresi', years: '(2-11 Temmuz 1932)' },
      { title: '1. Türkiye Büyük Millet Meclisi', years: '(1920-1923)' }
    ],
    '2': [
      { title: '2. TBMM Binası', years: '(1924-1960)' },
      { title: '2. Türk Tarih Kongresi', years: '(20-25 Eylül 1937)' },
      { title: '2. Türkiye Büyük Millet Meclisi', years: '(1923-1927)' }
    ]
  };
  const [data,setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedChar, setSelectedChar] = useState('');
  const getAPI = async () => {
    const resSlider = await getWriters();
    if (resSlider.status) {
      console.log('API Response:', resSlider.data);
      
      // API verilerini harflere göre gruplandır
      const groupedData = {};
      alphabet.forEach(letter => {
        const letterItems = resSlider.data.filter(writer => {
          const firstChar = writer.name.charAt(0).toUpperCase();
          return firstChar === letter;
        });
        if (letterItems.length > 0) {
          groupedData[letter] = letterItems;
        }
      });

      // Sayıları gruplandır
      // numbers.forEach(num => {
      //   const numItems = resSlider.data.filter(writer => {
      //     const firstChar = writer.name.charAt(0);
      //     return firstChar === num;
      //   });
      //   if (numItems.length > 0) {
      //     groupedData[num] = numItems;
      //   }
      // });

      setData(groupedData);
      setFilteredData(groupedData);
    }
  }

  useEffect(() => {
    getAPI();
  }, []);

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      // İlk harfi seç
      const firstAvailableLetter = Object.keys(data).sort()[0];
      setSelectedLetter(firstAvailableLetter);
    }
  }, [data]);

  // URL'den gelen state'i kontrol et
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const group = params.get('group');
    if (group && letterGroups[group]) {
      setSelectedGroup(group);
      setSelectedLetter(letterGroups[group][0]);
    } else {
      setSelectedGroup(null);
      setSelectedLetter('A');
    }
  }, [location]);

  const handleLetterClick = (letter) => {
    setSelectedLetter(letter);
    setSelectedChar(letter);
  };

  const handleGroupClick = (group) => {
    setSelectedGroup(group);
    const firstItem = letterGroups[group][0];
    setSelectedLetter(firstItem);
    setSelectedChar(firstItem);
  };

  // Görünecek harfleri belirle
  const visibleLetters = selectedGroup ? letterGroups[selectedGroup] : alphabet;

  return (
    <div className="authors-container">
      <div className="letter-groups mb-3">
        {Object.keys(letterGroups).map((group) => (
          <div 
            key={group} 
            className={`letter-group ${selectedGroup === group ? 'active' : ''}`}
            onClick={() => handleGroupClick(group)}
          >
            {group}
          </div>
        ))}
      </div>

      <div className="alphabet-nav">
        {visibleLetters.map((letter) => (
          <span 
            key={letter} 
            className={`letter ${selectedLetter === letter ? 'active' : ''}`}
            onClick={() => handleLetterClick(letter)}
          >
            {letter}
          </span>
        ))}
      </div>

      <div className="authors-content">
        <div className="letter-section">
          <div className="letter-title">{selectedLetter}</div>
          <img 
            src="/images/turksa/uzunCizgi.png" 
            alt="Dekoratif çizgi" 
            className="decorative-line"
          />
          <div className="authors-list">
            {filteredData && filteredData[selectedLetter]?.map((author, index) => (
              <Link 
                to={`/yazar/${author.id}`} 
                key={index} 
                className="author-item"
              >
                <span className="author-title-page">
                  {`${author.name} ${author.surname}`}
                </span>
                {author.itemCount > 0 && (
                  <span className="author-years">({author.itemCount} makale)</span>
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Authors; 